import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getAsnStateActionAsync } from '../redux/actions/asnStateActions'

export const useAsnState = () => {
  const { asnStatesState } = useSelector((state: RootState) => state.asnState)
  const dispatch = useDispatch()

  const getAsnState = () => {
    dispatch(getAsnStateActionAsync())
  }

  return { asnStatesState, getAsnState }
}
